import React, { useState } from "react";
import { navigate } from "gatsby";
import { stringify } from "query-string";

const Search = () => {
  const [query, setQuery] = useState("");

  const onChange = e => {
    const userInput = e.target.value;
    setQuery(userInput);
  };

  const search = e => {
    if (e.target.id === "search-button-sidebar" || e.keyCode === 13) {
      navigate(`/search?${stringify({ q: query })}`);
    }
  };

  return (
    <>
      <h3 className="bg-indigo-700 text-white text-center text-lg px-4 py-2 font-bold tracking-wider m-0">
        Search
      </h3>
      <div className="relative h-10 mt-2">
        <input
          onChange={onChange}
          onKeyDown={search}
          type="text"
          name="q"
          value={query}
          placeholder="Looking for..."
          className="absolute inset-0 h-full z-0 appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded-md py-3 pl-4 pr-12 leading-tight focus:outline-none focus:bg-white"
        />

        <button
          className="absolute right-0 h-full z-10 py-2 px-3 border-l border-gray-200 rounded-r-md focus:outline-none focus:shadow-outline"
          id="search-button-sidebar"
          onClick={search}
        >
          <i className="fa fa-search text-gray-700 font-bold align-middle pointer-events-none" />
        </button>
      </div>
    </>
  );
};

export default Search;